import { FaArrowLeft } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Autoplay, EffectCoverflow, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import DiwaliData2025 from "../../../../../../Data/Events/2025/DiwaliData2025";
import "../../CSSBlogs/MainBlogsCSSFile.css";

const HappyDiwali2025 = () => {
    return (
        <>
            <section className="carousel_slider_section">
                <div className="container carouselSliderFirstInnerDiv">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                        <Swiper
                                effect={"coverflow"}
                                grabCursor={true}
                                centeredSlides={true}
                                slidesPerView={"auto"}
                                coverflowEffect={{
                                    rotate: 0,
                                    stretch: 0,
                                    depth: 100,
                                    modifier: 2,
                                    // slideShadows: true,
                                }}
                                // pagination={{
                                //     clickable: true,
                                //     dynamicBullets: true,
                                // }}
                                loop={true}
                                autoplay={{ delay: 3000 }}
                                navigation={true}
                                modules={[EffectCoverflow, Navigation, Autoplay]}
                                className="mySwiper"
                            >
                                {
                                    DiwaliData2025.map((items) => {
                                        return (
                                            <SwiperSlide className="swiperSlide" key={items.id}>
                                                <div className="swiper-slide-img">
                                                    <img src={items.imageSource} alt="Avatar" className='nexus' />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            <section className="blogs-heading-and-para-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 blog-heading-and-para-div">
                            <h1>Diwali Celebration at Office – A Day of Light, Art, and Togetherness</h1>
                            <p>This Diwali, our office shone brighter than ever! The festival of lights brought with it a wave of joy, creativity, and togetherness that truly reflected the spirit of the season. As the HR and event organiser, I had the pleasure of coordinating a day filled with laughter, colours, and heartfelt moments shared among our team.</p>
                            <p>We began the celebrations by decorating the entire office with beautiful lights and vibrant rangoli designs. The workspace was transformed into a lively and festive atmosphere, glowing with diyas and smiles all around. Every corner sparkled with positivity, and it was heartwarming to see the enthusiasm each team member brought to make the place look so radiant.</p>
                            <p>To add a creative touch, we organised a Diya Painting Competition, which quickly became one of the highlights of the day. Employees channelled their artistic side, transforming simple clay lamps into vibrant pieces of art. The competition showcased an incredible range of designs—from traditional motifs to modern patterns and it was wonderful to see the thought and effort that went into every creation. Later in the day, I had the honour of announcing and awarding prizes to the winners, recognising their creativity and festive spirit.</p>
                            <p>Our celebrations continued with a Diwali Pooja, where everyone gathered to seek blessings for prosperity and success. The sound of chants and the soft glow of diyas filled the room with peace and positivity. After the pooja, we distributed Diwali gifts to all employees as a small token of appreciation for their hard work and contribution throughout the year.</p>
                            <p>Of course, no celebration is complete without memories captured in pictures! Our photo booth became a favourite spot for everyone.</p>
                            <p>Team members posed with festive props, shared laughs, and created snapshots that perfectly captured the day’s joy.</p>
                            <p>The Diwali celebration wasn’t just about decorations or competitions—it was about coming together as one team, sharing happiness, and spreading light both within and beyond our workplace. It reminded us that when we celebrate together, we grow stronger as a family.</p>
                            <p>This Diwali, our office didn’t just glow with lamps—it glowed with the spirit of unity, creativity, and joy.</p>
                        </div>
                        <div className="col-md-6 blog-writer-div">
                            <p>Written By ~ Ishika Das</p>
                        </div>
                        <div className="col-md-6 blog-button-div">
                            <NavLink to={"/events/more-events"} className="href">
                                <button>
                                    <span className="icon">
                                        <FaArrowLeft />
                                    </span>{" "}
                                    View All Events
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HappyDiwali2025;
